import moment from 'moment-timezone'

import { dateFormat } from 'app/common/api/requests/food/schools/cafeteria_orders'


const DEFAULT_PERIOD_DAYS = 7

const getDefaultPeriod = (
  dateStart?: string | null,
  dateFinish?: string | null,
): [string, string] => {
  const mDateStart = moment(dateStart)
  const mDateFinish = moment(dateFinish)

  const dateStartValid = !!dateStart && mDateStart.isValid()
  const dateFinishValid = !!dateFinish && mDateFinish.isValid()

  const mToday = moment()

  let mSelectedDateStart = mToday.clone().subtract(DEFAULT_PERIOD_DAYS - 1, 'days')
  let mSelectedDateFinish = mToday.clone()

  if (dateStartValid && mSelectedDateStart.isBefore(mDateStart, 'day')) {
    mSelectedDateStart = mDateStart.clone()
  }

  if (dateFinishValid && mSelectedDateFinish.isAfter(mDateFinish, 'day')) {
    mSelectedDateFinish = mDateFinish.clone()
  }

  if (mSelectedDateStart.isAfter(mSelectedDateFinish, 'day')) {
    mSelectedDateStart = mSelectedDateFinish.clone()
  }

  return [
    mSelectedDateStart.format(dateFormat),
    mSelectedDateFinish.format(dateFormat),
  ]
}

export default getDefaultPeriod
